module.exports = __webpack_public_path__ + "static/fugro-logo-c1851a705094c1d2cb19af98554df677.png";